import './testimony.css'
import kenya from "../assets/kenya.png"
import nigeria from "../assets/nigeria.png"
import southafrica from "../assets/southafrica.png"

const testimony = () => {
    return (
        <div>
            <section className="testimonials" id='testimonial'>
                <div className='testimonial-titles'>
                    <h2 className=''>- What Our Customers Are Saying</h2>
                    <p className=''>SureSend’s platform is trusted by businesses and <br /> entrepreneurs across Africa. 
                        Hear from our satisfied customers.</p>
                </div>
       
       <div className="testimonial-contents">
            <div className="testimonial-content">
                <div className="testimonial-header">
                    <img src={nigeria} alt="nigerian-flag" />
                    <h3>Business Owner in Nigeria</h3>
                </div>
                <i class="fa fa-quote-left " ></i>
                <p>
                
                    SureSend has revolutionized the way we handle payments. 
                    It’s not only fast and secure, but also so simple to use. 
                    We can now send payments to our suppliers in Europe without any hassle,
                    and the best part is, the funds are received almost instantly!
                    {/*  */}
                </p>
               
            </div>

            <div className="testimonial-content">
                <div className="testimonial-header">
                    <img src={kenya} alt="kenyan flag" />
                    <h3>Entrepreneur in Kenya</h3>
                </div>
                <i class="fa fa-quote-left " ></i>
                <p>
                    As a small business owner, I needed a way to send money across borders 
                    for international suppliers. SureSend made it possible with ease, 
                    and I’m confident in the security and compliance standards they maintain.
                </p>
            </div>

            <div className="testimonial-content">
                <div className="testimonial-header">
                    <img src={southafrica} alt="south-african-flag" />
                    <h3>Corporate Client in South Africa</h3>
                </div>
                <i class="fa fa-quote-left " ></i>
                <p>
                SureSend is a trusted partner for our international payment needs. 
                The real-time transfers have enabled us to expand our global 
                reach while maintaining smooth operations in Africa.
                </p>
            </div>
            
       </div>

   </section> 
        </div>
    )
}

export default testimony